import {RemoteObjectStore} from '@softline/core';
import {Kreditlimit} from './types/kreditlimit';

export const SOFTLINE_FEATURE_WWS_KREDITLIMIT = 'kreditlimit';

export const SOFTLINE_PERMISSION_WWS_KREDITLIMIT = 'KREDITLIMIT';
export const SOFTLINE_PERMISSION_WWS_KREDITLIMIT_WIDGET = 'KREDITLIMIT.WIDGET';

export const WwsKreditlimitStore = RemoteObjectStore.create<Kreditlimit>();
